<div class="card-body">
    <form [formGroup]="addressForm" novalidate>
        <h5 class="text-start text-primary fw-bold ps-2 ms-1 mt-2">{{type}} {{data.item}} Address</h5>
        <div class="row mx-0 mt-4">
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <input type="text" class="form-control" formControlName="Address1" autocomplete="off" maxlength="120" id="adr1" placeholder="Address Line 1" (input)="onInputChanged($event)" (blur)="spaceValidation($event, 'Address1')">
                    <label for="adr1">Address Line 1 <span class="text-danger">*</span></label>
                    <div *ngIf="addressForm.controls.Address1.touched && addressForm.controls.Address1.errors" class="ms-3 mt-2">
                        <span class="small text-danger">Please enter address line 1.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <input type="text" class="form-control" formControlName="Address2" autocomplete="off" maxlength="120" id="adr2" placeholder="Address Line 2" (input)="onInputChanged($event)" (blur)="spaceValidation($event, 'Address2')">
                    <label for="adr2">Address Line 2<span class="text-danger">*</span></label>
                    <div *ngIf="addressForm.controls.Address2.touched && addressForm.controls.Address2.errors" class="ms-3 mt-2">
                        <span class="small text-danger">Please enter address line 2.</span>
                    </div>
                </div>
            </div>
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <input type="text" class="form-control" formControlName="Address3" autocomplete="off" maxlength="120" id="adr3" placeholder="Address Line 3" (input)="onInputChanged($event)" (blur)="spaceValidation($event, 'Address3')">
                    <label for="adr3">Address Line 3 <span class="text-danger">*</span></label>
                    <div *ngIf="addressForm.controls.Address3.touched && addressForm.controls.Address3.errors" class="ms-3 mt-2">
                        <span class="small text-danger">Please enter address line 3.</span>
                    </div>
                </div>
            
            </div>
                <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                    <div class="form-floating mb-md-5 mb-4">
                        <input type="text" class="form-control" formControlName="City" autocomplete="off" maxlength="120" id="city" placeholder="City" (input)="onInputChange($event)" (blur)="spaceValidation($event, 'City')">
                        <label for="city">City <span class="text-danger">*</span></label>
                        <div *ngIf="addressForm.controls.City.touched && addressForm.controls.City.errors" class="ms-3 mt-2">
                            <span class="small text-danger">Please enter city name.</span>
                        </div>
                    </div>
                </div>
                
                <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                    <div class="form-floating mb-md-5 mb-4">
                        <input type="text" class="form-control" formControlName="State" autocomplete="off" maxlength="120" id="state" placeholder="State" (input)="onInputChange($event)" (blur)="spaceValidation($event, 'State')">
                        <label for="state">State <span class="text-danger">*</span></label>
                        <div *ngIf="addressForm.controls.State.touched && addressForm.controls.State.errors" class="ms-3 mt-2">
                            <span class="small text-danger">Please enter State name.</span>
                        </div>
                    </div>
                </div>
    
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <input type="text" class="form-control" formControlName="Pincode" autocomplete="off" maxlength="10" id="Pincode" placeholder="Pin Code" (blur)="spaceValidation($event, 'Pincode')" (input)="alphaNumerics($event)">
                    <label for="Pincode">Pin Code <span class="text-danger">*</span></label>
                    <div *ngIf="addressForm.controls.Pincode.touched && addressForm.controls.Pincode.errors" class="ms-3 mt-2">
                        <span class="small text-danger">Please enter Pin Code.</span>
                    </div>
                </div>
            </div>
    
            <div class="col-lg-6 pe-md-5 ps-md-2 px-0">
                <div class="form-floating mb-md-5 mb-4">
                    <select class="form-select" formControlName="Country" id="country" [ngClass]="addressForm.controls.Country.value ? 'optionValue' : ''">
                        <option [value]="list.Name" *ngFor="let list of countryList; let i = index">{{list.Name}}</option>
                    </select>
                    <label *ngIf="addressForm.controls.Country.value" for="country">Select Country <span class="text-danger">*</span></label>
                    <label *ngIf="!addressForm.controls.Country.value" for="country" class="form-select-label">Select Country <span class="text-danger">*</span></label>
               </div>
            </div>
        </div>
    </form>
</div>